<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								{{ pageTitle }}
							</div>
							<!-- Page Header -->
							<div class="page_main">
								<div class="btn_el">
									<div class="tips">Please enter the name of the new role and provide a description.</div>
								</div>
								<div class="form_box">
									<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
										<div class="input_el">
											<div class="tit required">Role Name</div>
											<el-form-item label="" prop="role_name">
												<el-input
													v-model="ruleForm.role_name"
													placeholder="Please enter"
													clearable
												></el-input>
											</el-form-item>
										</div>
										<div class="input_el">
											<div class="tit required">Role Description</div>
											<el-form-item label="" prop="description">
												<el-input
													type="textarea"
													:rows="5"
													v-model="ruleForm.description"
													placeholder="Please enter"
												></el-input>
											</el-form-item>
										</div>
										<div class="btn_el">
											<div class="tips">
												Assign users to the role and click "Save". The role will be enabled by default. Please make sure the corresponding user information has been completed before assigning users.
											</div>
										</div>
										<div class="input_el">
											<div class="tit required">Assigned Users</div>
											<el-form-item label="" prop="uid">
												<el-input
													v-model="userName"
													placeholder="Please select a user"
													@click.native="openUserDialog"
												>
													<i slot="suffix" class="el-input__icon el-icon-user"></i>
												</el-input>
											</el-form-item>
										</div>
									</el-form>
								</div>
								<div class="btn_box">
									<van-button class="btn_el" type="default" round @click="cancel">
										Cancel
									</van-button>
									<van-button
										class="btn_el"
										round
										color="linear-gradient(to right, #7BC1FF, #4886FF)"
										@click="submitForm('ruleForm')"
									>
										Save
									</van-button>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>

		<!-- User Selection Dialog -->
		<UserSelect
			:visible.sync="dialogVisible"
			:user-list="userList"
			:selected-id="selectedId"
			@confirm="handleConfirm"
		/>

		<!-- User Selection Dialog -->

		<!-- Loading -->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!-- Loading -->
	</div>
</template>

<script>
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	import UserSelect from "@/component/user-select.vue";
	import {
		roleDetail,
		roleAdd,
		roleEdit
	} from "../../../api/system/role";
	import {
		usersList
	} from "../../../api/system/user";
	export default {
		components: {
			headers,
			slider,
			UserSelect,
		},
		data() {
			return {
				isLoading: true,
				pageTitle: "",
				userName: "",
				selectedId: null,
				dialogVisible: false,
				userList: [],
				ruleForm: {
					role_name: "",
					description: "",
					role_userid: "",
				},
				rules: {
					role_name: [{
						required: true,
						message: "Please enter",
						trigger: "blur",
					}, ],
					description: [{
						required: true,
						message: "Please enter",
						trigger: "blur",
					}, ],
					role_userid: [{
						required: true,
						message: "Please select",
						trigger: "change",
					}, ],
				},
			};
		},
		created() {
			let that = this;
		},
		computed: {},
		mounted() {
			let that = this;
			if (that.$route.query.oid) {
				that.pageTitle = "Edit Role";
				usersList({
					page: 1,
					page_size: 99999,
					status: 1
				}).then((res2) => {
					if (res2.code == 200) {
						that.userList = res2.data.data;
						roleDetail({
							id: that.$route.query.oid
						}).then((res) => {
							if (res.code == 200) {
								that.ruleForm = {
									id: res.data.id,
									role_name: res.data.role_name,
									description: res.data.description,
									role_userid: res.data.role_userid,
								};
								that.userName = res.data.role_username;
								that.isLoading = false;
							}
						});
					}
				});
			} else {
				that.pageTitle = "Add Role";
				usersList({
					page: 1,
					page_size: 99999,
					status: 1
				}).then((res) => {
					if (res.code == 200) {
						that.userList = res.data.data;
					}
					that.isLoading = false;
				});
			}
		},

		methods: {
			openUserDialog() {
				let that = this;
				that.dialogVisible = true;
			},
			handleConfirm({
				id,
				user
			}) {
				let that = this;
				that.selectedId = id || null;
				that.ruleForm.role_userid = id || null;
				that.userName = user ? user.username : "";
			},
			//取消
			cancel() {
				this.$router.back();
			},
			//保存
			submitForm(formName) {
				let that = this;
				that.$refs[formName].validate((valid) => {
					if (valid) {
						that.$toast.loading({
							duration: 0,
							forbidClick: true,
						});
						if (that.pageTitle == "Add Role") {
							roleAdd(that.ruleForm).then((res) => {
								if (res.code == 200) {
									that.$toast.clear();
									that.$message("Operation successful");
									setTimeout(() => {
										window.location.reload();
									}, 800);
								}
							});
						} else if (that.pageTitle == "Edit Role") {
							roleEdit(that.ruleForm).then((res) => {
								if (res.code == 200) {
									that.$toast.clear();
									that.$message("Operation successful");
									setTimeout(() => {
										window.location.reload();
									}, 800);
								}
							});
						}
					} else {
						return false;
					}
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_box {
				text-align: center;

				.btn_el {
					margin-left: 10px;
					padding: 12px 24px;

					.van-button__text {
						font-size: 16px;
					}
				}
			}

			.form_box {
				.input_el {
					.tit {
						padding-bottom: 5px;
						font-size: 14px;
						color: #333333;
					}

					.required::before {
						content: "*";
						color: red;
						margin-right: 2px;
					}
				}
			}

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>

<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}
</style>